<template>
  <div class="cabinet-slide">
    <div
      class="cabinet-slide__image"
    >
      <div class="label flex al-center">
        <template
          v-for="(label, indx) in getLabel(
            _.get(slide_content, 'store_labels')
          )"
        >
          <div
            v-if="_.get(label, 'title')"
            class="label-item"
            :style="{ background: _.get(label, 'color.color') }"
            :key="indx"
          >
            {{ _.get(label, "title") }}
          </div>
        </template>
      </div>

      <picture>
        <source
          media="(max-width: 767px)"
          :srcset="`${_.get(slide_content, 'cover_image[0].devices.mobile')}`"
        />
        <source
          media="(max-width: 1023px)"
          :srcset="`${_.get(slide_content, 'cover_image[0].devices.tablet')}`"
        />
        <img
          :src="_.get(slide_content, 'cover_image[0].devices.desktop')"
          alt="image"
        />
      </picture>
    </div>
    <div class="cabinet-slide__content">
      <div class="flex between">
        <div class="title font-21 light uppercase text-overflow-hidden-2">
          {{ _.get(slide_content, "front_title") }}
        </div>
      
      </div>

      <div class="cabinet-slide__see-more-wrapper flex between">
        <div
          class="visit uppercase pointer bold flex al-center"
        >
          {{ $fn.tr("ვრცლად") }}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="7.857"
            height="10"
            viewBox="0 0 7.857 10"
          >
            <path
              id="Icon_material-play-arrow"
              data-name="Icon material-play-arrow"
              d="M12,7.5v10l7.857-5Z"
              transform="translate(-12 -7.5)"
              fill="#4d4d4f"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["slide_content"],
  methods: {
    getLabel(labelId) {
      const floorWidget = this.$store.state.main?.indx?.terms?.store_labels;
      const res = [];
      labelId && labelId.length
        ? labelId.forEach((label) => {
            res.push(floorWidget.find((item) => item.id == label));
          })
        : "";
      return res;
    },
  },

  mounted() {
    console.log(this.slide_content);
  },
};
</script>

<style lang="scss">
.cabinet-slide {
  &__image {
    width: 100%;
    height: 214px;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    background: $white;

    img {
      will-change: transform;
    }

    @include hover {
      img {
        transform: scale(1.1, 1.1);
      }
    }

    .label {
      position: absolute;
      top: 30px;
      left: 30px;

      .label-item {
        padding: 10px;
        height: 28px;
        display: flex;
        align-items: center;
        border-radius: 10px;
        z-index: 2;
        background: $yellow;
        color: $white;
        margin-right: 10px;
        font-size: 13px;
      }
    }
    img {
      width: 100%;
      height: 100%;
      position: absolute;
      object-fit: cover;
      transition: 0.3s linear;
      transform-origin: center center;
    }
  }
  &__content {
    padding-top: 21px;
    height: 102px;
    .title {
      color: $black;
      // margin-bottom: 20px;
    }
    .teaser {
      color: #4d4d4f;
      margin-bottom: 25px;
    }
    .visit {
      color: $black;
      margin-top: 21px;

      svg {
        margin-left: 10px;
        path {
          transition: 0.4s ease;
        }
      }
      transition: 0.4s ease;
      &:hover {
        color: $red;
        svg {
          path {
            fill: $red;
          }
        }
      }
    }
  }
  &__see-more-wrapper{
    position: absolute;
    bottom: 0;
    left: 0;
  }
  @media (max-width: 1550px) {
    &__image {
      height: 172px;
    }
    .label{
      top: 15px;
      left: 15px;
    }
  }
  @media (max-width: 1440px) {
    &__image {
      height: 138px;
    }
  }
  @media (max-width: 1439px) {
    &__image {
      height: 159px;
    }
  }
  @media (max-width: 1365px) {
    &__image{
      height: 0;
      // padding-bottom: calc(100% / 1.90517241379);
        padding-bottom: calc(100% / 1.89754098361);
    }
  }
  @media (max-width: 1125px){
    &__image{
      height: 0;
      padding-bottom: calc(100% / 1.89754098361);
    }
  }
}
</style>
